/**
 * PRD.330 — Shared payment-method values and labels.
 *
 * `invoice_payments.method` is free text in Postgres (default 'cash'); the
 * values below are the ones the payment-entry dialogs offer. Labels match
 * those dialogs. Unknown / legacy values must still render and stay
 * filterable, so `paymentMethodLabel` falls back to the raw stored value.
 *
 * The existing per-file copies (RecordPaymentDialog, NewPaymentDialog,
 * PaymentHistoryList, home-dashboard/shared.tsx) are intentionally NOT
 * migrated here yet — see PRD.330 §9.4 (deferred).
 */

export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash' },
  { value: 'card', label: 'Card' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'gcash', label: 'GCash' },
  { value: 'other', label: 'Other' },
] as const;

export type KnownPaymentMethod = (typeof PAYMENT_METHODS)[number]['value'];

const LABELS: ReadonlyMap<string, string> = new Map(PAYMENT_METHODS.map((m) => [m.value, m.label]));

export function isKnownPaymentMethod(value: string): value is KnownPaymentMethod {
  return LABELS.has(value);
}

/** Display label for a stored method; raw value for unknown methods, '—' when empty. */
export function paymentMethodLabel(value: string | null | undefined): string {
  if (value == null || value.trim() === '') return '—';
  return LABELS.get(value) ?? value;
}
